export default __webpack_public_path__ + "static/media/siphon.da65f1a7.svg";